import { cn } from '@reflex/ui/lib/utils';
import type { OnboardingProgress } from '@reflex/shared';

export interface OnboardingProgressIndicatorProps {
  /** Progress summary to visualize. */
  progress: OnboardingProgress;
  /** Title displayed alongside the progress segments. Pass `null` to hide. */
  title?: string | null;
  className?: string;
}

export function OnboardingProgressIndicator({
  progress,
  title = 'Finish setting up your workspace',
  className,
}: OnboardingProgressIndicatorProps) {
  return (
    <div className={cn('flex min-w-0 items-center gap-3', className)}>
      {title ? <p className="truncate text-sm font-medium text-foreground">{title}</p> : null}
      <div className="flex items-center gap-2">
        <div
          className="flex items-center gap-1"
          role="progressbar"
          aria-valuenow={progress.completed}
          aria-valuemin={0}
          aria-valuemax={progress.total}
          aria-label="Configuration progress"
        >
          {Array.from({ length: progress.total }).map((_, i) => (
            <span
              key={i}
              className={cn(
                'h-1 w-6 rounded-full transition-colors',
                i < progress.completed ? 'bg-status-accent-orange' : 'bg-status-accent-orange/20',
              )}
            />
          ))}
        </div>
        <p className="whitespace-nowrap text-xs font-medium text-muted-foreground tabular-nums">
          {progress.completed} / {progress.total}
        </p>
      </div>
    </div>
  );
}
